export type YesNo = 'yes' | 'no';

export type RetirementRecipientCategory = 'spouse' | 'dependents';

export type RetirementAllowanceStep =
  | 'intro'
  | 'gate'
  | 'recipientType'
  | 'pickSpouse'
  | 'pickDependent'
  | 'enterAmount'
  | 'addAnotherDependent'
  | 'review';

export type RetirementAllowanceEntry = {
  empFamilyId: number;
  memberFullName: string;
  memberRelationship: string;
  retirementAllowanceAmount: string;
};

export type RetirementAllowanceSnapshot = {
  anyExpected: YesNo | '';
  recipientCategory: RetirementRecipientCategory | '';
  entries: RetirementAllowanceEntry[];
};

export type FamilyMemberCandidate = {
  empFamilyId: number;
  fullName: string;
  relationship: string;
};

export const RETIREMENT_ALLOWANCE_STEP_ORDER: RetirementAllowanceStep[] = [
  'intro',
  'gate',
  'recipientType',
  'pickSpouse',
  'pickDependent',
  'enterAmount',
  'addAnotherDependent',
  'review',
];

export function emptyRetirementAllowanceSnapshot(): RetirementAllowanceSnapshot {
  return { anyExpected: '', recipientCategory: '', entries: [] };
}
